var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UniqueUserId } from '@xylabs/pixel';
import { delay } from '@xyo-network/sdk-xyo-js';
import { Cart } from '../useCart';
import CoinUserEventHandlerBase from './CoinUserEventHandlerBase';
import SnapchatEvents from './Snapchat';
import TestData from './TestData';
class SnapchatEventHandler extends CoinUserEventHandlerBase {
    constructor() {
        super(...arguments);
        this.events = new SnapchatEvents();
    }
    emailCollected(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            this.email = fields.email;
            yield delay(0);
        });
    }
    accountCreated() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    shareCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    buyticketsCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    installCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    funnelCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    offerRequested() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    feedbackScoreCollected() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    feedbackSourceCollected() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    goodFeedbackRequested() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    badFeedbackRequested() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    contactInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    addressInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    paymentInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.addBilling().send(this.buildCustomProperties());
        });
    }
    addToCart() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.addCart().send(this.buildCustomProperties());
        });
    }
    purchaseCompleted(payment) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const cart = Cart.get();
            yield this.events.purchase().send(this.buildCustomProperties({
                currency: 'USD',
                price: cart.getValue(),
                success: 1,
                transaction_id: (_c = (_b = (_a = payment.data) === null || _a === void 0 ? void 0 : _a.checkout) === null || _b === void 0 ? void 0 : _b.transaction) === null || _c === void 0 ? void 0 : _c.id,
            }));
        });
    }
    userClick(_fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    initiateCheckout() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.startCheckout().send(this.buildCustomProperties());
        });
    }
    purchaseAttempted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    purchaseFailed() {
        return __awaiter(this, void 0, void 0, function* () {
            const cart = Cart.get();
            yield this.events.purchase().send(this.buildCustomProperties({
                currency: 'USD',
                price: cart.getValue(),
                success: 0,
            }));
        });
    }
    upsellViewed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    upsellUnavailable() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    upsellAccepted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    trialStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    funnelStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    upsellSucceeded() {
        return __awaiter(this, void 0, void 0, function* () {
            const cart = Cart.get();
            yield this.events.purchase().send(this.buildCustomProperties({
                currency: 'USD',
                price: cart.getValue(),
                success: 1,
            }));
        });
    }
    upsellFailed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.purchaseFailed();
        });
    }
    testStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    viewContent(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.viewContent().send(this.buildCustomProperties(fields));
        });
    }
    buildCustomProperties(data) {
        const cart = Cart.get();
        const coinId = new UniqueUserId().id;
        const testData = new TestData().data;
        return Object.assign(Object.assign({}, data), { coinId, itemSet: cart.getItemSet(), testData, user_email: this.email });
    }
}
export default SnapchatEventHandler;
//# sourceMappingURL=SnapchatEventHandler.js.map